import React from "react";
import { Link } from "@/components/common/Link";
import { TrendingUp, ChartBar, Building2, Target } from "lucide-react";
const actions = [{
  icon: TrendingUp,
  title: "Wind Mitigation",
  href: "/WindMitigationInspectionPage"
}, {
  icon: ChartBar,
  title: "4-Point Check",
  href: "/FourPointInspectionSouthFloridaPage"
}, {
  icon: Building2,
  title: "Condo Specialist",
  href: "/CondoInspectionPage"
}, {
  icon: Target,
  title: "Mold Testing",
  href: "/MoldTestingPage"
}];
export default function ExpertiseActionGrid() {
  return <section data-section-id="248908" id="whycondoinspectionsmatter" className="w-full bg-background text-foreground">
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[600px]">
        {/* Left Grid of Action Cards */}
        <div className="flex items-center justify-center p-4 md:p-8 lg:p-12">
          <div className="grid w-full max-w-2xl grid-cols-1 gap-4 sm:grid-cols-2">
            {actions.map((action, i) => {
            const Icon = action.icon;
            return <Link key={i} to={action.href} data-index={i} className="group flex aspect-square flex-col items-center justify-center gap-6 bg-card p-8 text-center transition-all duration-300 hover:bg-accent border border-border shadow-sm hover:shadow-md rounded-lg sm:aspect-auto sm:py-16">
                  <Icon className="h-14 w-14 text-primary transition-transform duration-300 group-hover:scale-110" />
                  <span className="text-sm font-default font-bold tracking-widest text-foreground uppercase">
                    {action.title}
                  </span>
                </Link>;
          })}
          </div>
        </div>

        {/* Right Content Panel */}
        <div className="flex flex-col justify-center bg-secondary p-8 text-secondary-foreground md:p-12 lg:p-20">
          <div className="max-w-xl">
            <h2 className="mb-6 font-default text-3xl leading-tight font-bold lg:text-4xl uppercase tracking-tight">
              Why Condo Inspections Matter
            </h2>
            <p className="mb-6 text-lg leading-relaxed text-secondary-foreground/90 font-default">
              In South Florida's unique coastal environment, condo inspections are vital for identifying hidden structural issues, moisture intrusion, and aging systems. Our specialized team ensures your investment is protected with a thorough evaluation of both interior units and accessible common elements.
            </p>
            <p className="text-lg leading-relaxed text-secondary-foreground/90 font-default">
              We provide clear, unbiased reports delivered within 24 hours, helping you navigate insurance requirements and purchase decisions with confidence. From Miami-Dade to the Florida Keys, we bring local expertise to every high-rise and garden-style community we serve.
            </p>
          </div>
        </div>
      </div>
    </section>;
}